import { ArrowUpRight } from "lucide-react";
import { useBooking } from "@/components/site/BookingContext";
import { NAV_SERVICES } from "@/lib/content";

export default function Footer() {
  const { openBooking } = useBooking();
  const year = new Date().getFullYear();

  return (
    <footer className="relative bg-navy-950 text-white">
      <div className="w-full max-w-[1400px] mx-auto px-5 md:px-10 py-16">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5 mb-5">
              <span className="relative flex h-6 w-6 items-center justify-center">
                <span className="absolute inset-0 rounded-full bg-white/20 blur-md" />
                <span className="relative h-2 w-2 rounded-full bg-white" />
              </span>
              <span className="font-display font-bold tracking-tight text-lg">Favor<span className="text-white/50">.</span>Studio</span>
            </div>
            <p className="text-white/55 max-w-sm leading-relaxed">
              AI Dispatchers built specifically for residential HVAC companies. Answer every call, qualify every lead, and book more jobs 24/7.
            </p>
            <button
              onClick={openBooking}
              data-testid="footer-book-btn"
              className="mt-6 inline-flex items-center gap-2 h-11 px-5 rounded-sm border border-white/20 hover:border-white/50 hover:bg-white/5 font-medium transition-colors"
            >
              Book a Live Demo <ArrowUpRight className="w-4 h-4" />
            </button>
          </div>

          <div className="md:col-span-3 md:col-start-8">
            <p className="text-xs uppercase tracking-[0.2em] text-white/40 mb-4">Services</p>
            <ul className="space-y-3">
              {NAV_SERVICES.map((s) => (
                <li key={s.href}>
                  <a href={s.href} className="text-white/70 hover:text-white transition-colors">{s.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="text-xs uppercase tracking-[0.2em] text-white/40 mb-4">Company</p>
            <ul className="space-y-3">
              <li><a href="#faq" className="text-white/70 hover:text-white transition-colors">FAQ</a></li>
              <li><a href="#pricing" className="text-white/70 hover:text-white transition-colors">Pricing</a></li>
              <li><a href="mailto:contact@favorstudio.agency" className="text-white/70 hover:text-white transition-colors">Contact</a></li>
            </ul>
          </div>
        </div>

        {/* Desktop/tablet — unchanged from before */}
        <div className="mt-14 pt-6 border-t border-white/10 hidden sm:flex items-center justify-between gap-3">
          <p className="text-xs text-white/40">© {year} Favor Studio LLC. All rights reserved.</p>
          <div className="flex items-center gap-6 text-xs text-white/40">
            <span className="flex items-center gap-1.5">
              <a href="#" className="hover:text-white/70 transition-colors">Privacy</a>
              <span>·</span>
              <a href="#" className="hover:text-white/70 transition-colors">Terms</a>
            </span>
            <span className="whitespace-nowrap">The infrastructure behind your next great customer experience.</span>
          </div>
        </div>

        {/* Mobile — stacked and centered, no forced nowrap so long lines wrap instead of overflowing */}
        <div className="mt-14 pt-6 border-t border-white/10 flex sm:hidden flex-col items-center gap-3 text-center">
          <p className="text-xs text-white/40">© {year} Favor Studio LLC. All rights reserved.</p>
          <p className="text-xs text-white/40 max-w-[85%]">The infrastructure behind your next great customer experience.</p>
          <span className="flex items-center gap-1.5 text-xs text-white/40">
            <a href="#" className="hover:text-white/70 transition-colors">Privacy</a>
            <span>·</span>
            <a href="#" className="hover:text-white/70 transition-colors">Terms</a>
          </span>
        </div>
      </div>
    </footer>
  );
}
